import { render, staticRenderFns } from "./FaturamentoEvolucaoSupervisorTime.vue?vue&type=template&id=237a40f9&scoped=true&"
import script from "./FaturamentoEvolucaoSupervisorTime.vue?vue&type=script&lang=js&"
export * from "./FaturamentoEvolucaoSupervisorTime.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoEvolucaoSupervisorTime.vue?vue&type=style&index=0&id=237a40f9&scoped=true&lang=css&"
import style1 from "./FaturamentoEvolucaoSupervisorTime.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a40f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
